import { t } from '../i18n/index.ts';

/**
 * H-304 — o selo «Pago». Verde sobre verde-claro, com o ✓ e a palavra: a
 * cor nunca é o único sinal (RNF-022). O texto por omissão é «Pago»; a
 * página de preços diz «Já tens acesso», que é a mesma coisa dita a quem
 * está a decidir se compra.
 */
export function SeloPago({ texto }: { texto?: string }) {
  return (
    <span className="selo-pago" aria-label={t('acesso.pagoAria')}>
      <span aria-hidden="true">✓ </span>
      {texto ?? t('acesso.pago')}
    </span>
  );
}
